import { API_CUSTOMER_MENU_URL } from '@/constants/config';
import { fetch } from '@/utils/fetch';

export interface GetBranchConfiguration {
  digitalMenuEnabled: boolean;
  digitalOrderingEnabled: boolean;
}

export const getBranchConfiguration = (
  brandId: string,
  outletId: string
): Promise<GetBranchConfiguration> =>
  fetch
    .get<GetBranchConfiguration>(
      `${API_CUSTOMER_MENU_URL}/branch-menus/configurations?brand-id=${brandId}&outlet-id=${outletId}`
    )
    .then(response => response.data);
